<template>
  <div>
    <el-dialog custom-class="editor-dialog" :center="center" :close-on-click-modal="closeOnClickModal" :width="width" :visible="dialogVisible" top="8vh"
      :z-index="2000" :before-close="handleClose" @open="onDialogOpen">
      <template #title>
        <span>{{editorTitle}}</span>
      </template>
      <div class="backgroud-white cs-editor-content">
        <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="100px">
          <el-form-item label="人员" prop="label">
            <el-autocomplete :disabled="readonly" v-model="model.label" placeholder="请选择或输入人员" class="input-width" value-key="Name"
              :fetch-suggestions="queryPersonnelSearch" @change="handlePersonnelChange" @select="handlePersonnelSelect" />
            <!-- 二阶段增加评估内容 -->
            <!-- <el-tooltip effect="light" placement="top" content="添加">
              <el-link v-show="!this.selectedPersonnel" :underline="false" class="input-btn" @click="onPersonnelAdd"><i class="el-icon-plus" /></el-link>
            </el-tooltip>
            <el-tooltip effect="light" placement="top" content="移除">
              <el-link v-show="!!this.selectedPersonnel && !!this.selectedPersonnel.Id" :underline="false" class="input-btn" @click="onPersonnelRemove"><i
                  class="el-icon-delete" />
              </el-link>
            </el-tooltip> -->
          </el-form-item>
          <el-form-item label="职位" prop="positionName">
            <el-autocomplete :disabled="readonly" v-model="model.positionName" placeholder="请选择或输入职位" class="input-width" value-key="Name"
              :fetch-suggestions="queryPositionSearch" @change="handlePositionChange" @select="handlePositionSelect" />
            <!-- 二阶段增加评估内容 -->
            <!-- <el-tooltip effect="light" placement="top" content="添加">
              <el-link v-show="!this.selectedPosition" :underline="false" class="input-btn" @click="onPositionAdd"><i class="el-icon-plus" /></el-link>
            </el-tooltip>
            <el-tooltip effect="light" placement="top" content="移除">
              <el-link v-show="!!this.selectedPosition && !this.selectedPosition.IsRoleType" :underline="false" class="input-btn" @click="onPositionRemove"><i
                  class="el-icon-delete" />
              </el-link>
            </el-tooltip> -->
          </el-form-item>
          <!-- <el-form-item label="是否负责人" prop="isManager">
            <el-switch :disabled="true" v-model="model.isManager" active-color="#006AB4" inactive-color="#E3E3E3">
            </el-switch>
          </el-form-item> -->
          <el-form-item label="电话" prop="phone">
            <el-input placeholder="请输入电话" :disabled="readonly" v-model="model.phone" class="input-width" />
          </el-form-item>
          <el-form-item label="头像">
            <div class="avatar-content">
              <el-avatar class="upload-file" :size="64" :src="avatarPath" />
              <span v-if="!readonly">
                <el-button size="small" type="primary" plain @click="openAvatarUploader">上传</el-button>
                <el-button v-if="!!model.avatarFileId" size="small" type="primary" plain @click="removeAvatar">移除</el-button>
              </span>
            </div>
          </el-form-item>
          <el-form-item v-if="!readonly" label="面试视频">
            <div>
              <el-button v-if="!!model.interviewRecordingName" class="upload-file" :loading="isInterviewRecordingDownloading" type="text" size="medium"
                @click="showInterviewRecordingVideo">
                {{model.interviewRecordingName}}</el-button>
              <span>
                <el-button size="small" type="primary" plain @click="openInterviewRecordingUploader">上传</el-button>
                <el-button v-if="!!model.interviewRecordingName" size="small" type="primary" plain @click="downloadInterviewRecording">下载</el-button>
                <el-button v-if="!!model.interviewRecordingId" size="small" type="primary" plain @click="removeInterviewRecording">移除</el-button>
              </span>
            </div>

          </el-form-item>
          <el-form-item v-if="!readonly" label="简历文件">
            <div>
              <el-button v-if="!!model.resumeFileName" class="upload-file" :loading="isResumeFileDownloading" type="text" size="medium"
                @click="downloadResumeFile">
                {{model.resumeFileName}}</el-button>
              <span>
                <el-button size="small" type="primary" plain @click="openResumeFileUploader">上传</el-button>
                <el-button v-if="!!model.resumeFileId" size="small" type="primary" plain @click="removeResumeFile">移除</el-button>
              </span>
            </div>
          </el-form-item>
          <el-form-item v-if="!readonly" label="备注" prop="comment">
            <el-input type="textarea" :rows="3" placeholder="请输入备注" :disabled="readonly" v-model="model.comment" class="input-width" />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer popup-footer">
          <el-row>
            <el-col>
              <el-button v-if="!readonly" :disabled="isSaving" :loading="isSaving" type="primary" @click="saveChanges">保存</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>

    <el-dialog center title="上传头像" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="avatarUploaderVisible" top="8vh"
      z-index="2000">
      <blob-uploader @closeEditor="closeAvatarUploader" @blobUploadError="onAvatarUploaderUploadError" @blobUploaded="onAvatarUploaderUploaded" :type="15"
        :accepts="'.png,.jpg,.jpeg'" :isVisible="avatarUploaderVisible" :isAutoSave="true"></blob-uploader>
    </el-dialog>
    <el-dialog center title="上传面试视频" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="interviewRecordingUploaderVisible" top="8vh"
      z-index="2000">
      <blob-uploader @closeEditor="closeInterviewRecordingUploader" @blobUploadError="onInterviewRecordingUploaderUploadError"
        @blobUploaded="onInterviewRecordingUploaderUploaded" :type="16" :accepts="'.avi,.mpeg,.mpg,.mp4,.rm,.rmvb,.mov,.asf,.wmv,.mkv,.3gp,.flv'"
        :isVisible="interviewRecordingUploaderVisible" :isAutoSave="true"></blob-uploader>
    </el-dialog>
    <el-dialog center title="上传简历文件" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="resumeFileUploaderVisible" top="8vh"
      z-index="2000">
      <blob-uploader @closeEditor="closeResumeFileUploader" @blobUploadError="onResumeFileUploaderUploadError"
        @blobUploaded="onResumeFileUploaderUploaded" :type="17" :isVisible="resumeFileUploaderVisible" :isAutoSave="true"></blob-uploader>
    </el-dialog>
    <el-dialog center title="" :show-close="true" :close-on-click-modal="false" width="700px" height="600px" :visible.sync="interviewRecordingVideoVisible" top="8vh"
      z-index="3000">
      <div v-if="!!model.interviewRecordingId && interviewRecordingVideoVisible" class="video-content">
        <video :src="interviewRecordingPath" controls />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import emptyAvatarPath from "@/assets/profile.png";
import { downloadFile } from "@/config/mUtils";
import { OrgChartNode } from "@/components/orgChart/orgChartNode";
import { getSharedAccessSignature } from "@/service/blobStorage.service";
import { downloadFileToBlob } from "@/service/blobStorage.service";
import {
  getPositions,
  savePosition,
  removePosition,
  getPersonnels,
  savePersonnel,
  removePersonnel,
  savePersonnelSaveData,
} from "@/service/oganization.service";

const mixin_general = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
    validateField(props) {
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validateField(props);
      }
    },
    convertBlobUrl(originalUrl) {
      if (!originalUrl) return String.empty;

      if (!this.blobSasKey || originalUrl.contains(OrgChartNode.blobSasKey))
        return originalUrl;

      return `${originalUrl}${this.blobSasKey}`;
    },
    sortPositionItems() {
      this.positionItems.sort((itemA, itemB) => {
        let result = 0;

        result = itemA.IsRoleType - itemB.IsRoleType;

        if (!result) {
          result = itemA.Id - itemB.Id;
        }

        return result;
      });
    },
    sortPersonnelItems() {
      this.personnelsItems.sort((itemA, itemB) => {
        let result = 0;

        let isOriginalEmployeeA = !itemA.Id && !!itemA.EmployeeId ? 1 : 0;
        let isOriginalEmployeeB = !itemB.Id && !!itemB.EmployeeId ? 1 : 0;
        result = isOriginalEmployeeA - isOriginalEmployeeB;

        if (!result) {
          result = itemA.Id - itemB.Id;
        }

        if (!result) {
          result = itemA.EmployeeId - itemB.EmployeeId;
        }

        return result;
      });
    },
  },
};

const default_modelData = {
  dataId: 0,
  nodeType: 2,
  parentDataId: 0,
  parentNodeType: 1,
  label: null,
  nodeType: 2,
  personnelId: 0,
  employeeId: null,
  positionId: 0,
  positionName: null,
  isRoleType: false,
  isManager: false,
  phone: null,
  avatarFileId: null,
  avatarUrl: null,
  interviewRecordingId: null,
  interviewRecordingName: null,
  interviewRecordingUrl: null,
  resumeFileId: null,
  resumeFileName: null,
  resumeFileUrl: null,
  comment: null,
};

export default {
  name: "orgPersonnelNodeEditor",
  mixins: [mixin_general],
  components: {
    blobUploader: () => import("@/components/fileHandler/blobUploader"),
  },
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "35%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    sasKey: String,
    positions: Array,
    parentNode: Object,
    data: Object,
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      isSaving: false,
      dialogVisible: false,
      rules: {
        label: [
          {
            required: true,
            message: "请选择或输入人员",
            trigger: "blur",
          },
          {
            max: 250,
            message: "人员名称不可超过250个字符",
            trigger: "blur",
          },
        ],
        positionName: [
          {
            required: true,
            message: "请选择或输入职位",
            trigger: "blur",
          },
          {
            max: 250,
            message: "职位名称不可超过250个字符",
            trigger: "blur",
          },
        ],
      },
      blobSasKey: null,
      positionItems: [],
      personnelsItems: [],
      model: Object.clone(default_modelData),
      selectedPersonnel: null,
      selectedPosition: null,
      avatarUploaderVisible: false,
      interviewRecordingUploaderVisible: false,
      isInterviewRecordingDownloading: false,
      interviewRecordingVideoVisible: false,
      resumeFileUploaderVisible: false,
      isResumeFileDownloading: false,
    };
  },
  created() {
    this.reloadVisible();
  },
  computed: {
    editorTitle() {
      let personnelTypeText = this.model.isManager ? "负责人" : "人员";
      if (this.readonly) return `查看${personnelTypeText}`;

      if (!!this.model.dataId) return `编辑${personnelTypeText}`;

      return `新增${personnelTypeText}`;
    },
    avatarPath() {
      if (!!this.model.avatarUrl) return this.model.avatarUrl;

      return emptyAvatarPath;
    },
    interviewRecordingPath() {
      if (!!this.model.interviewRecordingUrl)
        return this.convertBlobUrl(this.model.interviewRecordingUrl);

      return null;
    },
    resumeFilePath() {
      if (!!this.model.resumeFileUrl)
        return this.convertBlobUrl(this.model.resumeFileUrl);

      return null;
    },
  },
  methods: {
    async loadSharedAccessSignatureFromServer() {
      try {
        let result = await getSharedAccessSignature(true);
        if (!!result && result.success) {
          this.sasKey = result.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadPositionItemsFromServer() {
      try {
        let result = await getPositions();
        if (!!result && result.success) {
          this.positionItems = result.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadPersonnelsItemsFromServer() {
      try {
        let result = await getPersonnels(true);
        if (!!result && result.success) {
          this.personnelsItems = result.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async savePositionToServer() {
      try {
        let saveData = this._getPositionAddData();
        let result = await savePosition(saveData);
        if (!!result && result.success && !!result.data) {
          this.$message.success("保存职位成功");
          return result.data;
        } else {
          this.$message.error(`保存职位失败。${result.message}`);
        }
      } catch (error) {
        console.error(error);
      }

      return null;
    },
    async removePositionToServer() {
      try {
        let id = this.selectedPosition.Id;
        let result = await removePosition(id);
        if (!!result && result.success && result.data) {
          this.$message.success("移除职位成功。");
          return result.data;
        } else {
          this.$message.error(`移除职位失败。${result.message}`);
        }
      } catch (error) {
        console.error(error);
      }

      return false;
    },
    async savePersonnelToServer() {
      try {
        let saveData = this._getPersonnelAddData();
        let result = await savePersonnel(saveData);
        if (!!result && result.success && !!result.data) {
          this.$message.success("保存人员成功。");
          return result.data;
        } else {
          this.$message.error(`保存人员失败。${result.message}`);
        }
      } catch (error) {
        console.error(error);
      }

      return null;
    },
    async savePersonnelSaveDataToServer() {
      try {
        let saveData = this._getSaveData();
        let result = await savePersonnelSaveData(saveData);
        if (!!result && result.success && !!result.data) {
          this.$message.success("保存成功。");
          return result.data;
        } else {
          this.$message.error(`保存失败。${result.message}`);
        }
      } catch (error) {
        console.error(error);
      }

      return null;
    },
    async removePersonnelToServer() {
      try {
        let id = this.selectedPersonnel.Id;
        let result = await removePersonnel(id);
        if (!!result && result.success && result.data) {
          this.$message.success("移除人员成功。");
          return result.data;
        } else {
          this.$message.error(`移除人员失败。${result.message}`);
        }
      } catch (error) {
        console.error(error);
      }

      return false;
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible === newValue) return;

      this.dialogVisible = newValue;
      if (this.dialogVisible) this.reloadDataFromProps();
    },
    resetData() {
      this.model = Object.clone(default_modelData);
    },
    async reloadDataFromProps() {
      if (!this.dialogVisible) return;

      if (!this.sasKey) await this.loadSharedAccessSignatureFromServer();
      else this.blobSasKey = this.sasKey;
      if (!this.positions || this.positions.length === 0)
        await this.loadPositionItemsFromServer();
      else this.positionItems = this.positions;
      await this.loadPersonnelsItemsFromServer();

      let newModel = Object.clone(default_modelData);
      if (!!this.data) {
        newModel.dataId = this.data.dataId;
        newModel.nodeType = this.data.nodeType;
        newModel.parentDataId = this.data.parentDataId;
        newModel.parentNodeType = this.data.parentNodeType;
        newModel.label = this.data.label;
        newModel.personnelId = this.data.meta.personnelId;
        newModel.positionId = this.data.meta.positionId;
        newModel.isRoleType = this.data.meta.isRoleType;
        newModel.isManager = this.data.meta.isManager;
        newModel.phone = this.data.meta.phone;
        newModel.avatarFileId = this.data.meta.avatarFileId;
        newModel.avatarUrl = this.data.meta.avatarUrl;
        newModel.interviewRecordingId = this.data.meta.interviewRecordingId;
        newModel.interviewRecordingName = this.data.meta.interviewRecordingName;
        newModel.interviewRecordingUrl = this.data.meta.interviewRecordingUrl;
        newModel.resumeFileId = this.data.meta.resumeFileId;
        newModel.resumeFileName = this.data.meta.resumeFileName;
        newModel.resumeFileUrl = this.data.meta.resumeFileUrl;
        newModel.comment = this.data.meta.comment;

        let matchedPersonnel = this.personnelsItems.find(
          (item) => item.Id === newModel.personnelId
        );
        if (!!matchedPersonnel) {
          newModel.employeeId = matchedPersonnel.EmployeeId;
          this.selectedPersonnel = matchedPersonnel;
        }

        let matchedPosition = this.positionItems.find(
          (item) =>
            item.Id === newModel.positionId &&
            item.IsRoleType === newModel.isRoleType
        );
        if (!!matchedPosition) {
          newModel.positionName = matchedPosition.Name;
          this.selectedPosition = matchedPosition;
        }
      } else {
        newModel.parentDataId = this.parentNode.dataId;
        newModel.parentNodeType = this.parentNode.nodeType;
      }

      this.model = newModel;
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.resetFields();
      }
    },
    showDialog(isManager = false) {
      default_modelData.isManager = isManager;
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog() {
      this.interviewRecordingVideoVisible = false;
      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadDataFromProps();
    },
    handleClose(done) {
      this.$nextTick(async () => {
        this.resetData();

        this.closeDialog();
      });
    },
    queryPositionSearch(queryString, cb) {
      let dataList = this.positionItems;
      if (!!queryString) {
        dataList = dataList.filter((item) =>
          item.Name.toLowerCase().contains(queryString.toLowerCase())
        );
      }
      cb(dataList);
    },
    handlePositionChange(value) {
      this.selectedPosition = this.positionItems.find(
        (item) => item.Name === value
      );
      this._fixPositionData();
    },
    handlePositionSelect(data) {
      this.selectedPosition = data;
      this._fixPositionData();

      this.$nextTick(() => {
        this.validateField(["positionName"]);
      });
    },
    onPositionAdd() {
      if (!!this.selectedPosition) {
        this.$message.error("当前输入职位为已有职位，不能添加");
        return;
      }

      this.$confirm(`您确认要将当前输入添加为新职位吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        async () => {
          let id = await this.savePositionToServer();
          if (!!id) {
            let newItem = {
              Id: id,
              Name: this.model.positionName,
              IsRoleType: false,
            };
            this.positionItems.insert(0, newItem);
            this.sortPositionItems();
            this.selectedPosition = newItem;
          }
        },
        () => {}
      );
    },
    onPositionRemove() {
      if (!this.selectedPosition) {
        this.$message.error("当前输入职位非已有职位，不能移除");
        return;
      }

      if (this.selectedPosition.IsRoleType) {
        this.$message.error("当前输入职位为系统角色，不能移除");
        return;
      }

      this.$confirm(`您确认要移除当前选择的职位吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        async () => {
          let result = await this.removePositionToServer();
          if (result) {
            this.positionItems.remove(this.selectedPosition);
            this.selectedPosition = null;
            this.model.positionName = null;
          }
        },
        () => {}
      );
    },
    queryPersonnelSearch(queryString, cb) {
      let dataList = this.personnelsItems;
      if (!!queryString) {
        dataList = dataList.filter((item) =>
          item.Name.toLowerCase().contains(queryString.toLowerCase())
        );
      }
      cb(dataList);
    },
    handlePersonnelChange(value) {
      this.selectedPersonnel = this.personnelsItems.find(
        (item) => item.Name === value
      );
      this._fixPersonnelData();
    },
    handlePersonnelSelect(data) {
      this.selectedPersonnel = data;
      this._fixPersonnelData();

      if (!!this.selectedPersonnel.PositionId) {
        let matchedPosition = this.positionItems.find(
          (item) => item.Id === this.selectedPersonnel.PositionId
        );
        if (!!matchedPosition) {
          this.selectedPosition = matchedPosition;
          this.model.positionName = matchedPosition.Name;
          this._fixPositionData();
        }
      }

      this.$nextTick(() => {
        this.validateField(["label"]);
      });
    },
    onPersonnelAdd() {
      if (!!this.selectedPersonnel) {
        this.$message.error("当前输入人员为已有人员，不能添加");
        return;
      }

      this.$confirm(`您确认要将当前输入添加为新人员吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        async () => {
          let id = await this.savePersonnelToServer();
          if (!!id) {
            let newItem = {
              Id: id,
              Name: this.model.label,
              Phone: this.model.phone,
              EmployeeId: null,
              Comment: this.model.comment,
              PersonnelId: id,
              AvatarUrl: null,
              PositionId: null,
            };
            this.personnelsItems.insert(0, newItem);
            this.sortPersonnelItems();
            this.selectedPersonnel = newItem;
          }
        },
        () => {}
      );
    },
    onPersonnelRemove() {
      if (!this.selectedPersonnel) {
        this.$message.error("当前输入人员非已有人员，不能移除");
        return;
      }

      if (this.selectedPersonnel.Id === 0) {
        this.$message.error("当前输入人员为原始系统角色，不能移除");
        return;
      }

      this.$confirm(`您确认要移除当前选择的人员吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        async () => {
          let result = await this.removePersonnelToServer();
          if (result) {
            if (!!this.selectedPersonnel.EmployeeId) {
              this.$set(this.selectedPersonnel, "Id", 0);
              this.sortPersonnelItems();
            } else {
              this.personnelsItems.remove(this.selectedPersonnel);
              this.selectedPersonnel = null;
              this.model.label = null;
            }
          }
        },
        () => {}
      );
    },
    openAvatarUploader() {
      this.avatarUploaderVisible = true;
    },
    closeAvatarUploader() {
      this.avatarUploaderVisible = false;
    },
    onAvatarUploaderUploadError() {},
    onAvatarUploaderUploaded(data) {
      this.$set(this.model, "avatarFileId", data.FileId);
      this.$set(this.model, "avatarUrl", data.Path);

      this.closeAvatarUploader();
    },
    removeAvatar() {
      this.$confirm(`您确认要移除当前头像吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        () => {
          this.$set(this.model, "avatarFileId", null);
          this.$set(this.model, "avatarUrl", null);
        },
        () => {}
      );
    },
    openInterviewRecordingUploader() {
      this.interviewRecordingUploaderVisible = true;
    },
    closeInterviewRecordingUploader() {
      this.interviewRecordingUploaderVisible = false;
    },
    onInterviewRecordingUploaderUploadError() {},
    onInterviewRecordingUploaderUploaded(data) {
      this.$set(this.model, "interviewRecordingId", data.FileId);
      this.$set(this.model, "interviewRecordingName", data.FileName);
      this.$set(this.model, "interviewRecordingUrl", data.Path);

      this.closeInterviewRecordingUploader();
    },
    removeInterviewRecording() {
      this.$confirm(`您确认要移除当前面试记录吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        () => {
          this.$set(this.model, "interviewRecordingId", null);
          this.$set(this.model, "interviewRecordingName", null);
          this.$set(this.model, "interviewRecordingUrl", null);
        },
        () => {}
      );
    },
    showInterviewRecordingVideo() {
      this.interviewRecordingVideoVisible =
        !this.interviewRecordingVideoVisible;
    },
    downloadInterviewRecording() {
      if (!this.interviewRecordingPath) return;

      let fileName = this.model.interviewRecordingName;
      this.isInterviewRecordingDownloading = true;
      downloadFileToBlob(this.interviewRecordingPath, 0).then(
        (res) => {
          downloadFile({ data: res.data, filename: fileName });
          this.isInterviewRecordingDownloading = false;
        },
        () => {}
      );
    },
    openResumeFileUploader() {
      this.resumeFileUploaderVisible = true;
    },
    closeResumeFileUploader() {
      this.resumeFileUploaderVisible = false;
    },
    onResumeFileUploaderUploadError() {},
    onResumeFileUploaderUploaded(data) {
      this.$set(this.model, "resumeFileId", data.FileId);
      this.$set(this.model, "resumeFileName", data.FileName);
      this.$set(this.model, "resumeFileUrl", data.Path);

      this.closeResumeFileUploader();
    },
    removeResumeFile() {
      this.$confirm(`您确认要移除当前简历文件吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        () => {
          this.$set(this.model, "resumeFileId", null);
          this.$set(this.model, "resumeFileName", null);
          this.$set(this.model, "resumeFileUrl", null);
        },
        () => {}
      );
    },
    downloadResumeFile() {
      if (!this.resumeFilePath) return;

      let fileName = this.model.resumeFileName;
      this.isResumeFileDownloading = true;
      downloadFileToBlob(this.resumeFilePath, 0).then(
        (res) => {
          downloadFile({ data: res.data, filename: fileName });
          this.isResumeFileDownloading = false;
        },
        () => {}
      );
    },
    saveChanges() {
      this._fixModelData();

      let isValid = this.validate();
      if (!isValid) return;

      this.$nextTick(async () => {
        let savedData = await this.savePersonnelSaveDataToServer();
        if (!!savedData) {
          let node = this.data;
          if (!node) {
            node = this._getNodeFromSaveData(savedData);

            if (!this.parentNode.childrenPersonnel)
              this.$set(this.parentNode, "childrenPersonnel", []);

            this.parentNode.childrenPersonnel.push(node);
            this.parentNode.setToChildrenPersonnelEx(node);

            if (!this.parentNode.expand)
              this.$set(this.parentNode, "expand", true);
          } else {
            node = this._getNodeFromSaveData(savedData, node);
          }

          this.$emit("saveSuccess");
          this.closeDialog();
        }
      });
    },
    _fixPositionData() {
      if (!this.selectedPosition) {
        var matchedItem = this.positionItems.find(
          (item) => item.Name === this.model.positionName
        );
        if (!!matchedItem) this.selectedPosition = matchedItem;
      }
      this.model.positionId = !!this.selectedPosition
        ? this.selectedPosition.Id
        : 0;
      this.model.isRoleType = !!this.selectedPosition
        ? this.selectedPosition.IsRoleType
        : false;
    },
    _fixPersonnelData(useDefaultInfo = true) {
      if (!this.selectedPersonnel) {
        var matchedItem = this.personnelsItems.find(
          (item) => item.Name === this.model.label
        );
        if (!!matchedItem) this.selectedPersonnel = matchedItem;
      }

      this.model.personnelId = !!this.selectedPersonnel
        ? this.selectedPersonnel.Id
        : 0;
      this.model.employeeId = !!this.selectedPersonnel
        ? this.selectedPersonnel.EmployeeId
        : null;

      if (useDefaultInfo && !!this.selectedPersonnel) {
        this.model.avatarFileId = this.selectedPersonnel.AvatarFileId;
        this.model.avatarUrl = this.selectedPersonnel.AvatarUrl;
        this.model.interviewRecordingId =
          this.selectedPersonnel.InterviewRecordingId;
        this.model.interviewRecordingName =
          this.selectedPersonnel.InterviewRecordingName;
        this.model.interviewRecordingUrl =
          this.selectedPersonnel.InterviewRecordingUrl;
        this.model.resumeFileId = this.selectedPersonnel.ResumeFileId;
        this.model.resumeFileName = this.selectedPersonnel.ResumeFileName;
        this.model.resumeFileUrl = this.selectedPersonnel.ResumeFileUrl;
        this.model.phone = this.selectedPersonnel.Phone;
        this.model.comment = this.selectedPersonnel.Comment;
      }
    },
    _fixModelData() {
      this._fixPositionData();
      this._fixPersonnelData(false);
    },
    _getPositionAddData() {
      this._fixPositionData();

      return {
        Id: 0,
        Name: this.model.positionName,
      };
    },
    _getPersonnelAddData() {
      this._fixPersonnelData();

      return {
        Id: 0,
        Name: this.model.label,
        Phone: this.model.phone,
        Comment: this.model.comment,
      };
    },
    _getSaveData() {
      return {
        Id: this.model.dataId,
        Name: this.model.label,
        Phone: this.model.phone,
        EmployeeId: this.model.employeeId,
        AvatarFileId: this.model.avatarFileId,
        AvatarUrl: this.model.avatarUrl,
        InterviewRecordingId: this.model.interviewRecordingId,
        InterviewRecordingUrl: this.model.interviewRecordingUrl,
        ResumeFileId: this.model.resumeFileId,
        ResumeFileUrl: this.model.resumeFileUrl,
        Comment: this.model.comment,
        PersonnelId: this.model.personnelId,
        PositionId: this.model.positionId,
        PositionName: this.model.positionName,
        IsRoleType: this.model.isRoleType,
        IsManager: this.model.isManager,
        DepartmentId: this.model.parentDataId,
      };
    },
    _getNodeFromSaveData(saveData, node = null) {
      if (!node) {
        node = OrgChartNode.createPersonnelNode(this.parentNode);
      }

      node.dataId = saveData.Id;
      node.parentDataId = saveData.DepartmentId;
      node.label = saveData.Name;
      node.meta.personnelId = saveData.PersonnelId;
      node.meta.phone = saveData.Phone;
      node.meta.avatarFileId = saveData.AvatarFileId;
      node.meta.avatarUrl = saveData.AvatarUrl;
      node.meta.interviewRecordingId = saveData.InterviewRecordingId;
      node.meta.interviewRecordingUrl = saveData.InterviewRecordingUrl;
      node.meta.resumeFileId = saveData.ResumeFileId;
      node.meta.resumeFileUrl = saveData.ResumeFileUrl;
      node.meta.comment = saveData.Comment;
      node.meta.positionId = saveData.PositionId;
      node.meta.isRoleType = saveData.IsRoleType;
      node.meta.isManager = saveData.IsManager;
      node.meta.interviewRecordingName = this.model.interviewRecordingName;

      return node;
    },
  },
  watch: {
    visible(newValue) {
      this.reloadVisible(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .editor-dialog {
    min-width: 400px;

    .el-dialog__header {
      font-size: 1.75em;
      font-weight: bold;
    }
  }
}

.video-content {
  margin-top: 10px;

  video {
    width: 100%;
    height: 100%;
  }
}
    
.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    margin-bottom: 12px;

    .el-link {
      line-height: initial;
    }

    .el-avatar {
      vertical-align: middle;
    }

    .el-button {
      margin-left: inherit;
    }

    .input-width {
      width: 90%;
    }

    .input-btn {
      color: red;
    }

    .avatar-content {
      margin-top: calc((40px - 64px) / 2);
    }

    .upload-file {
      margin-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orgChart/orgPersonnelNodeEditor.vue